//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "alliance_mystore",
    data() {
        return {
            title: "我的门店",
            url: window.location.href, //当前地址
            storeShow: false, //是否绑定了店铺
            listShow: true, //门店信息是否为空
            shopList: [], //门店信息
            coupon_info: "", //优惠券信息
            description: "", //优惠券说明
            showTips: false, // 兑换弹框
            state: false, //说明弹框
            shopIds: [], //店铺id集合
            distanceList: [], //距离集合
            page: 1,
            per_page: 5,
            score: "" //用户可用积分
        };
    },
    created() {
        if (sessionStorage.getItem("token") == null) {
            this.get_token(this.url);
        } else {
            this.get_conf();
            this.get_scroe();
        }
    },
    methods: {
        //获取token
        get_token(url) {
            var self = this;
            this.$EpetJs.Common.approve(url, function() {
                self.get_conf();
                self.get_scroe();
                self.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
            }); //生成token
        },
        get_conf() {
            //微信js授权config
            var self = this;
            this.$EpetJs.Common.get_conf(this.url, function(res) {
                self.$wx.config(res.data.conf);
                self.storeShow = true;
                self.$wx.error(function(res) {
                    alert("出错了：" + res.errMsg); //这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
                });
            });
        },
        //获取当前位置经纬度
        get_LatLong() {
            var self = this;
            this.$wx.getLocation({
                type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: function(res) {
                    self.getDistanceList(res.latitude, res.longitude); // 经度，浮点数，范围为180 ~ -180    // 纬度，浮点数，范围为90 ~ -90
                },
                fail: function() {},
                cancel: function(res) {
                    alert("用户拒绝授权获取地理位置");
                }
            });
        },
        //获取距离
        getDistanceList(latitude, longitude) {
            var self = this;
            this.$EpetJs.Common.get(
                "/v2/public/user/shops/distance?shop_ids=" +
                    this.shopIds +
                    "&longitude=" +
                    longitude +
                    "&latitude=" +
                    latitude,
                {}
            ).then(({ data }) => {
                if (data.status_code == "200") {
                    self.distanceList = data.data;
                } else {
                    self.$vux.toast.text(data.message);
                }
            });
        },
        //距离转换
        distanceChange(distance) {
            if (distance < 1000) {
                return distance + "m";
            } else if (1000 < distance < 10000) {
                return (distance / 1000).toFixed("1") + "km";
            } else if (distance > 10000) {
                return parseInt(distance / 1000) + "km";
            }
        },
        infiniteHandler($state) {
            if (sessionStorage.getItem("token") == null) {
                return;
            }
            this.get_myshop($state);
        },
        //获取用户可用积分
        get_scroe() {
            var self = this;
            this.$EpetJs.Common.get("public/user/score", {}).then(
                ({ data }) => {
                    if (data.status_code == "200") {
                        self.score = data.data.score;
                    }else{
                        self.$vux.toast.text(data.message);  
                    }
                }
            );
        },
        //获取我的门店信息
        get_myshop($state) {
            var self = this;
            this.$EpetJs.Common.get(
                "/v2/public/user/shops?page=" +
                    this.page +
                    "&per_page=" +
                    this.per_page,
                {}
            ).then(({ data }) => {
                if (data.status_code == "200") {
                    // self.shopList=data.data;
                    if (data.data.length > 0) {
                        self.shopList = self.shopList.concat(data.data);
                        self.page += 1;
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                    //获取店铺数组
                    for (var i in self.shopList) {
                        self.shopIds.push(self.shopList[i].id);
                    }
                    if (self.shopList == "") {
                        self.listShow = false;
                    } else {
                        self.listShow = true;
                        self.$wx.ready(function() {
                            self.get_LatLong();
                        });
                    }
                }
            });
        },
        //去店铺
        go_shop(mobile, iswall) {
            this.$router.push({
                name: "alliance_shopcode",
                query: { mobile: mobile }
            });
        },
        //获取每个优惠券信息
        get_coupon(coupon_info) {
            this.coupon_info = coupon_info;
            this.showTips = true;
        },
        //点击兑换
        exchange() {
            //优惠券ID
            var self = this;
            this.$EpetJs.Common.post(
                "public/user/coupons/" + this.coupon_info.id + "/exchange",
                {
                    shop_id:
                        self.coupon_info.coupon_type == 2
                            ? self.coupon_info.shop_id
                            : ""
                }
            ).then(({ data }) => {
                if (data.status_code == "200") {
                    this.$router.push({
                        name: "alliance_myexchange",
                        query: { status: 1 }
                    });
                } else {
                    self.$vux.toast.text(data.message);
                    self.showTips = false;
                }
            });
        },
        //兑换弹窗显示
        openTips() {
            this.showTips = true;
        },
        //说明弹窗显示
        stateShow(coupon) {
            this.state = true;
            this.description = coupon.description;
        },
        //去绑定
        go_bindshop() {
            this.$router.push({ name: "alliance_bindshop" });
        }
    }
};
